import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class RoleService {
  // Get auth headers
  getAuthHeaders() {
    const token = localStorage.getItem('streamToken');
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  }

  // Get all roles
  async getAllRoles() {
    try {
      const response = await axios.get(`${API_URL}/roles`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get role statistics
  async getRoleStats() {
    try {
      const response = await axios.get(`${API_URL}/roles/stats`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get single role by ID
  async getRoleById(id) {
    try {
      const response = await axios.get(`${API_URL}/roles/${id}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Create new role
  async createRole(roleData) {
    try {
      const response = await axios.post(`${API_URL}/roles`, roleData, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Update role
  async updateRole(id, roleData) {
    try {
      const response = await axios.put(`${API_URL}/roles/${id}`, roleData, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Delete role
  async deleteRole(id) {
    try {
      const response = await axios.delete(`${API_URL}/roles/${id}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get all available permissions
  async getAllPermissions() {
    try {
      const response = await axios.get(`${API_URL}/roles/permissions`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Assign role to user
  async assignRoleToUser(userId, roleId) {
    try {
      const response = await axios.post(`${API_URL}/roles/assign`, {
        userId,
        roleId
      }, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get current user's permissions
  async getUserPermissions() {
    try {
      const response = await axios.get(`${API_URL}/roles/user/permissions`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Check if user has specific permission
  async checkPermission(permission) {
    try {
      const response = await axios.post(`${API_URL}/roles/user/check-permission`, {
        permission
      }, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Handle errors
  handleError(error) {
    if (error.response) {
      const message = error.response.data?.error || 'An error occurred';
      throw new Error(message);
    }
    throw new Error('Network error');
  }
}

export default new RoleService();
